import {FC, useState, createContext, useContext, useMemo} from 'react'
import {
    ID,
    calculatedGroupingIsDisabled,
    calculateIsAllDataSelected,
    groupingOnSelect,
    initialListView,
    ListViewContextProps,
    groupingOnSelectAll,
    WithChildren,
} from '../../../../_metronic/helpers'

import {useApplicationQueryResponse, useApplicationQueryResponseData} from './ApplicationQueryResponseProvider'

const ApplicationListViewContext = createContext<ListViewContextProps>(initialListView)

const ApplicationListViewProvider: FC<WithChildren> = ({children}) => {

    const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
    const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)
    
    const {isLoading} = useApplicationQueryResponse()
    const data = useApplicationQueryResponseData()
    const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
    const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

    const [itemIdForDelete, setItemIdForDelete] = useState<ID>(initialListView.itemIdForDelete)

    return (
    <ApplicationListViewContext.Provider
        value={{
            selected,
            itemIdForUpdate,
            setItemIdForUpdate,
            itemIdForDelete,
            setItemIdForDelete,
            disabled,
            isAllSelected,
            onSelect: (id: ID) => {
            groupingOnSelect(id, selected, setSelected)
            },
            onSelectAll: () => {
            groupingOnSelectAll(isAllSelected, setSelected, data)
            },
            clearSelected: () => {
            setSelected([])
            },
        }}
    >
        {children}
    </ApplicationListViewContext.Provider>
    )
}

const useApplicationListView = () => useContext(ApplicationListViewContext)

export { ApplicationListViewProvider, useApplicationListView }
